import type { DesktopModelView } from '../types.js';

export function modelCustomerLabel(model: DesktopModelView): string {
  const name = model.customerModelName ?? model.displayName;
  return model.customerProviderName ? `${model.customerProviderName} / ${name}` : name;
}
